module.exports = {
      id: "video-outline-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#video-outline",
      toString: function () {
        return this.url;
      }
    }